<template>
  <div class="agencies-box">
    <div class="personalMainHead">
      <PersonalHead
        type="initiation_single"
        titleNamePrefix="业务管理 >"
        titleName="业务详情"
      ></PersonalHead>
    </div>

    <div class="top_data_box">
      <div class="left">
        <div class="tabs">
          <div
            class="tab"
            :class="{ 'active-tab': active === 'detail' }"
            @click="onTab('detail')"
          >
            <div>公证详情</div>
          </div>
          <div
            class="tab"
            :class="{ 'active-tab': active === 'fileList' }"
            @click="onTab('fileList')"
          >
            <div>文件列表</div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="status-box">
          <div class="status-intro" v-if="info.basicInfo.operateStatus">
            {{ info.basicInfo.operateStatus }}
          </div>
          <div class="status-mes" v-if="info.basicInfo.bizStatus">
            <div class="status-text">{{ info.basicInfo.bizStatus }}</div>
            <img
              src="../../../assets/images/business/blz.png"
              class="status-image"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <div class="content-box">
      <div class="content-left">
        <!-- 公证详情 -->
        <FlowPath :info="info" v-if="active === 'detail'" />
        <!-- 公证列表 -->
        <FileList @onChoose="onChoose" :info="info" v-if="active === 'fileList'" />
      </div>
      <div class="content-right">
        <!-- 公证详情 -->
        <DetailInfo :info="info" v-if="active === 'detail'" />
        <!-- 公证列表 -->
        <div v-if="active === 'fileList'" style="height: 100%;">
          <PreviewFile
            v-if="fileActive === 'contractFile'"
            :info="info"
            :fileArr="fileArr"
          />
          <div class="preview-image" v-if="fileActive === 'idCardFace'">
            <el-image
              style="width: 50%"
              :src="info.fileUrlMap.idCardFace"
              :preview-src-list="[info.fileUrlMap.idCardFace]"
              v-if="info.fileUrlMap.idCardFace"
            >
            </el-image>
            <el-empty v-else description="暂无内容"></el-empty>
          </div>
          <div class="preview-image" v-if="fileActive === 'idCardLogo'">
            <el-image
              style="width: 50%"
              :src="info.fileUrlMap.idCardLogo"
              :preview-src-list="[info.fileUrlMap.idCardLogo]"
              v-if="info.fileUrlMap.idCardLogo"
            >
            </el-image>
            <el-empty v-else description="暂无内容"></el-empty>
          </div>
        </div>
      </div>
    </div>

    <div class="footer" v-if="info.basicInfo.bizStatus === '办理中' && active === 'detail'">
      <el-button
        class="footer-button"
        size="mini"
        type="danger"
        reset-button
        @click="dialogVisible = true"
        >记录</el-button
      >
    </div>

    <Loading v-if="isLoading"></Loading>

    <el-dialog
      title="请输入沟通记录"
      :visible.sync="dialogVisible"
      width="550px"
      :close-on-click-modal="false"
    >
      <div class="comm-box">
        <div class="comm-title">
          请输入沟通记录

          <i class="el-icon-close" @click="dialogVisible = false"></i>
        </div>
        <div>
          <el-input
            type="textarea"
            :rows="7"
            placeholder="点击输入原因"
            v-model.trim="note"
            maxlength="200"
            show-word-limit
            resize="none"
          >
          </el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="noteSubmit">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>
    
  <script>
import BaseApi from "@lib/baseApi.js";

import PersonalHead from "../../common/PersonalHead.vue";
import FlowPath from "./components/flowPath.vue";
import DetailInfo from "./components/detailInfo.vue";
import FileList from "./components/fileListView.vue";
import PreviewFile from "./components/previewFile.vue";

export default {
  name: "",
  props: {},

  components: {
    PersonalHead,
    FlowPath,
    DetailInfo,
    FileList,
    PreviewFile,
  },

  data() {
    return {
      active: "detail",

      id: "",

      info: {
        basicInfo: {
          handingTimes: [],
        },
        commNotes: {},
        fileUrlMap: {
          contractFile: "", // 合同文件
          idCardFace: "", // 身份证人像面
          idCardLogo: "", // 身份证国徽面
        },
        processList: [],
      },

      fileActive: "contractFile",

      businessDynamics: "", // 业务动态

      dialogVisible: false,
      note: "",

      fileNameMap: {
        contractFile: "合同文件",
      },
      fileArr: [], // 预览文件数组
    };
  },

  created() {
    this.businessDynamics = this.$route.query.businessDynamics;
    this.id = this.$route.query.id;
    this.getDetail();
  },
  mounted() {},

  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  methods: {
    // 获取详情
    async getDetail() {
      this.$store.commit("showLoading", true);
      await BaseApi.createRpcToken(
        "/notaryApply/getBizInfo",
        {
          id: this.id,
        },
        "get"
      )
        .then((data) => {
          this.$store.commit("showLoading", false);
          if (data && data.datas) {
            if (data.datas.basicInfo) {
              if (!data.datas.basicInfo.handingTimes) {
                data.datas.basicInfo.handingTimes = [
                  null,
                  null,
                  null,
                  null,
                  null,
                  null,
                ];
              }
            }

            if (data.datas.fileUrlMap && data.datas.fileUrlMap.contractFile) {
              this.fileArr = [
                {
                  filePath: data.datas.fileUrlMap.contractFile,
                },
              ];
            }
            this.info = data.datas;
          } else {
            this.$message.error(data.message);
          }
        })
        .catch(function (e) {
          this.$store.commit("showLoading", false);
        });
    },
    onTab(type) {
      this.active = type;
    },

    beforeClose(done, type) {
      console.log(done, type);
    },

    noteSubmit() {
      if (!this.note) {
        this.$message.info("提交内容不能为空");
        return;
      }
      this.$confirm(
        "提交后该备注将记录在系统中，展示给银行管理人员。确认是否提交？",
        "提示",
        {
          confirmButtonText: "提交",
          cancelButtonText: "取消",
        }
      )
        .then(async () => {
          this.dialogVisible = false;
          this.$store.commit("showLoading", true);
          await BaseApi.createRpcToken(
            "/notaryApply/addCommNote",
            {
              notaryApplyId: this.info.basicInfo.notaryApplyId,
              note: this.note,
            },
            "post"
          )
            .then((data) => {
              this.$store.commit("showLoading", false);
              if (data && data.datas) {
                this.getDetail();
                this.note = "";
                this.$message.success("记录成功");
              } else {
                this.$message.error(data.message);
              }
            })
            .catch(function (e) {
              this.$store.commit("showLoading", false);
            });
        })
        .catch(() => {});
    },

    onChoose(type) {
      this.fileActive = type;
    }
  },
};
</script>
    
  <style scoped lang='scss'>
.agencies-box {
  background-color: #eaedf1;
  width: 100%;
  min-height: 100vh;
  padding-top: 60px;
  padding-bottom: 76px;
  .personalMainHead {
    width: 100%;
    height: 60px;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 100;
  }

  .top_data_box {
    width: 90%;
    min-width: 1200px;
    min-height: 60px;
    background-color: #fff;
    margin: 5px auto 0px;
    display: flex;
    align-items: center;
    padding: 0 109px 0 0;
    box-sizing: border-box;
    .left {
      flex: 1;
      position: relative;
      height: 60px;
      .tabs {
        display: flex;
        align-items: center;
        position: absolute;
        bottom: 0;
        left: 15px;
        font-size: 11px;
        font-weight: 400;
        color: #505050;
        .tab {
          width: 92px;
          height: 43px;
          line-height: 43px;
          text-align: center;
          border-radius: 2px 2px 0 0;
          margin-right: 12px;
          cursor: pointer;
          border: 1px solid #e9e9e9;
          &.active-tab {
            background-color: #db1c1b;
            color: #ffffff;
            border: 1px solid #db1c1b;
          }
        }
      }
    }
    .right {
      .status-box {
        display: flex;
        align-items: center;
        .status-intro {
          height: 26px;
          background: #f8f8f8;
          border-radius: 2px;
          line-height: 26px;
          padding: 0 11px;
          color: #bdbdbd;
          font-size: 11px;
          text-align: center;
          margin-right: 23px;
        }
        .status-mes {
          display: flex;
          align-items: center;
          .status-text {
            font-size: 13px;
            color: #505050;
            line-height: 19px;
          }
          .status-image {
            width: 30px;
            height: 30px;
            margin-left: 4px;
          }
        }
      }
    }
  }

  .content-box {
    width: 90%;
    min-width: 1200px;

    min-height: calc(100vh - 210px);
    overflow: auto;
    background-color: #fff;
    margin: 5px auto 0px;
    box-sizing: border-box;
    display: flex;
    .content-left {
      width: 373px;
      border-right: 7px solid #eaedf1;
      padding: 31px 0;
    }
    .content-right {
      flex: 1;
      padding: 10px 30px;
      background-color: #ffffff;
      position: relative;

      .preview-image {
        height: 100%;
        // padding: 10px 20px;
        background: #eaedf1;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .footer {
    width: 100%;
    height: 71px;
    background-color: #ffffff;
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    .footer-button {
      min-width: 94px;
    }
    .reset-button {
      border-radius: 2px;
      padding: 7px 15px;
      &.el-button--danger {
        color: #fff;
        background-color: #db1c1b;
        border-color: #db1c1b;
      }
    }
  }
}

.comm-box {
  padding: 16px;
  .comm-title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 16px;
    position: relative;
    .el-icon-close {
      position: absolute;
      right: 0;
      top: 0;
      font-size: 20px;
      cursor: pointer;
    }
  }
}
</style>
    